export default __webpack_public_path__ + "static/media/plus.83500b79.svg";